import { AbstractControl, UntypedFormArray, ValidationErrors } from "@angular/forms";

export function serviceOrDataset(control: AbstractControl): ValidationErrors | null {
    const services: UntypedFormArray = control.get("services") as UntypedFormArray;
    const datasets: UntypedFormArray = control.get("datasets") as UntypedFormArray;
    const serviceorDatasetSelected = services.controls.length || datasets.controls.length;

    return serviceorDatasetSelected ? null : { serviceOrDatasetMissing: true };
}
